<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74"
    height="72"
    viewBox="0 0 74 72"
    fill="none"
  >
    <path
      d="M0 23.667H74V42.3522L67.2288 52.6866L36.6891 58.7324L6.28758 52.6866L0 42.3522V23.667Z"
      fill="#304970"
    />
    <path
      d="M10.2876 1.93457H63.7124C65.3693 1.93457 66.7124 3.27772 66.7124 4.93457V58.1006C66.7122 59.316 65.9801 60.4022 64.8735 60.8662L64.647 60.9512L37.9341 69.707C37.403 69.881 36.8356 69.902 36.2954 69.7715L36.0659 69.707L9.35303 60.9512C8.12089 60.5473 7.28779 59.3972 7.2876 58.1006V4.93457C7.2876 3.27772 8.63074 1.93457 10.2876 1.93457Z"
      :fill="surfaceColor"
      :stroke="primaryColor"
      stroke-width="2"
    />
    <rect
      x="36.7581"
      y="59.457"
      width="0.48366"
      height="5.80392"
      :fill="primaryColor"
    />
    <rect
      x="33.8562"
      y="60.4248"
      width="0.48366"
      height="3.86928"
      :fill="primaryColor"
    />
    <rect
      x="39.6602"
      y="60.4248"
      width="0.48366"
      height="3.86928"
      :fill="primaryColor"
    />
    <path
      d="M0 22.667L18.75 23.5836L37.5 24.5002L74 22.667V43.5297L37.5 42.5002L0 43.5297V22.667Z"
      fill="white"
    />
    <path
      d="M55.3475 20.4066V10.6773H53.3574V8.73145H59.7257V10.6773H57.7356V20.4066H55.3475Z"
      fill="white"
    />
    <path
      d="M49.1914 20.4659C48.0415 20.4659 47.2602 20.2301 46.7296 19.7436C46.2726 19.3161 46.022 18.6233 46.022 17.6356V15.9846H48.4101V17.783C48.4101 18.3727 48.6902 18.6675 49.1914 18.6675C49.6926 18.6675 49.9727 18.3874 49.9727 17.8272C49.9727 17.2228 49.6631 16.7364 49.2061 16.2057L47.275 13.9503C46.5379 13.0953 46.0809 12.4614 46.0809 11.2673C46.0809 10.4271 46.3905 9.70475 47.0096 9.24776C47.4961 8.87923 48.2184 8.67285 49.2208 8.67285C50.238 8.67285 50.9898 8.84975 51.491 9.29199C52.0217 9.74897 52.3313 10.4418 52.3313 11.4147V12.8004H49.9432V11.2673C49.9432 10.7366 49.6631 10.4713 49.2208 10.4713C48.7786 10.4713 48.4985 10.7366 48.4985 11.1199C48.4985 11.5622 48.7491 11.9454 49.3093 12.6088L51.1372 14.7463C51.8743 15.6013 52.3902 16.4415 52.3902 17.6356C52.3902 18.6085 52.0954 19.2571 51.5647 19.7289C51.0193 20.2006 50.2233 20.4659 49.1914 20.4659Z"
      fill="white"
    />
    <path
      d="M39.6592 20.4066V8.73145H45.0545V10.6773H42.0473V13.3307H45.0545V15.2766H42.0473V18.4607H45.0545V20.4066H39.6592Z"
      fill="white"
    />
    <path
      d="M29.3607 20.4066L27.7244 8.73145H30.0977L30.9232 16.338L31.7488 8.73145H34.8739L35.6994 16.338L36.5249 8.73145H38.6919L37.0556 20.4066H34.0337L33.2081 12.9917L32.3826 20.4066H29.3607Z"
      fill="white"
    />
    <path
      d="M23.573 20.4659C22.3495 20.4659 21.583 20.1858 21.0818 19.6846C20.6395 19.2424 20.3889 18.6233 20.3889 17.6061V11.5327C20.3889 10.5155 20.6395 9.89638 21.0818 9.45414C21.583 8.95294 22.3495 8.67285 23.573 8.67285C24.7966 8.67285 25.5631 8.95294 26.0643 9.45414C26.5066 9.89638 26.7572 10.5155 26.7572 11.5327V17.6061C26.7572 18.6233 26.5066 19.2424 26.0643 19.6846C25.5631 20.1858 24.7966 20.4659 23.573 20.4659ZM23.573 18.8444C23.8236 18.8444 24.03 18.7559 24.1627 18.6233C24.2806 18.5053 24.3691 18.2989 24.3691 17.9009V11.2378C24.3691 10.8398 24.2806 10.6335 24.1627 10.5155C24.03 10.3828 23.8236 10.2944 23.573 10.2944C23.3224 10.2944 23.1161 10.3828 22.9834 10.5155C22.8655 10.6335 22.777 10.8398 22.777 11.2378V17.9009C22.777 18.2989 22.8655 18.5053 22.9834 18.6233C23.1161 18.7559 23.3224 18.8444 23.573 18.8444Z"
      fill="white"
    />
    <path
      d="M14.0261 20.4066V8.73145H16.4142V18.4607H19.4215V20.4066H14.0261Z"
      fill="white"
    />
    <path
      d="M52.9246 40.256V27.0039H59.0486V29.2126H55.6352V32.2244H59.0486V34.4331H55.6352V38.0473H59.0486V40.256H52.9246Z"
      :fill="primaryColor"
    />
    <path
      d="M45.9992 40.3234C44.6104 40.3234 43.7403 40.0055 43.1714 39.4366C42.6695 38.9346 42.385 38.2319 42.385 37.0773V30.1836C42.385 29.0291 42.6695 28.3263 43.1714 27.8243C43.7403 27.2554 44.6104 26.9375 45.9992 26.9375C47.388 26.9375 48.2581 27.2554 48.827 27.8243C49.329 28.3263 49.6134 29.0291 49.6134 30.1836V31.6226H46.9028V29.8489C46.9028 29.3972 46.8024 29.1629 46.6685 29.0291C46.5179 28.8785 46.2837 28.7781 45.9992 28.7781C45.7148 28.7781 45.4805 28.8785 45.3299 29.0291C45.1961 29.1629 45.0957 29.3972 45.0957 29.8489V37.412C45.0957 37.8638 45.1961 38.098 45.3299 38.2319C45.4805 38.3825 45.7148 38.4829 45.9992 38.4829C46.2837 38.4829 46.5179 38.3825 46.6685 38.2319C46.8024 38.098 46.9028 37.8638 46.9028 37.412V35.2368H49.6134V37.0773C49.6134 38.2319 49.329 38.9346 48.827 39.4366C48.2581 40.0055 47.388 40.3234 45.9992 40.3234Z"
      :fill="primaryColor"
    />
    <path
      d="M36.3718 40.256V27.0039H39.0825V40.256H36.3718Z"
      :fill="primaryColor"
    />
    <path
      d="M25.8325 40.256V27.0039H30.2833C31.3709 27.0039 31.9733 27.2382 32.4084 27.6732C32.8267 28.0915 33.0609 28.6771 33.0609 29.748V30.7352C33.0609 31.8061 32.8267 32.3917 32.4084 32.8101C32.1908 33.0276 31.9398 33.1949 31.6052 33.2953C32.1072 33.4626 32.5087 33.7805 32.7597 34.1988C32.9605 34.5335 33.0609 34.9518 33.0609 35.755V40.256H30.3503V35.504C30.3503 35.0522 30.2499 34.8179 30.116 34.6841C29.9654 34.5335 29.7144 34.4331 29.2794 34.4331H28.5432V40.256H25.8325ZM28.5432 32.2244H29.2794C29.7144 32.2244 29.9654 32.1408 30.116 31.9734C30.2499 31.8228 30.3503 31.5384 30.3503 31.0197V30.2835C30.3503 29.8317 30.2499 29.5974 30.116 29.4636C29.9654 29.313 29.7144 29.2126 29.2794 29.2126H28.5432V32.2244Z"
      :fill="primaryColor"
    />
    <path
      d="M15.293 40.256V27.0039H19.7438C20.8314 27.0039 21.4338 27.2382 21.8688 27.6732C22.2871 28.0915 22.5214 28.6771 22.5214 29.748V33.061C22.5214 34.1319 22.2871 34.7175 21.8688 35.1359C21.4338 35.5709 20.8314 35.8052 19.7438 35.8052H18.0036V40.256H15.293ZM18.0036 33.5965H18.7398C19.1749 33.5965 19.4259 33.5128 19.5765 33.3455C19.7103 33.1949 19.8107 32.9104 19.8107 32.3917V30.2835C19.8107 29.8317 19.7103 29.5974 19.5765 29.4636C19.4259 29.313 19.1749 29.2126 18.7398 29.2126H18.0036V33.5965Z"
      :fill="primaryColor"
    />
    <path
      d="M57.2371 54.663V46.4404H61.0369V47.8109H58.919V49.6796H61.0369V51.0501H58.919V53.2926H61.0369V54.663H57.2371Z"
      fill="white"
    />
    <path
      d="M52.3989 54.663V46.4404H56.1988V47.8109H54.0808V49.6796H56.1988V51.0501H54.0808V53.2926H56.1988V54.663H52.3989Z"
      fill="white"
    />
    <path
      d="M48.2773 54.663V47.8109H46.8757V46.4404H51.3608V47.8109H49.9592V54.663H48.2773Z"
      fill="white"
    />
    <path
      d="M41.1655 54.663V46.4404H43.2419L44.3632 50.4583V46.4404H45.8375V54.663H43.9687L42.6398 49.8873V54.663H41.1655Z"
      fill="white"
    />
    <path
      d="M35.2893 54.663L36.421 46.4404H39.0061L40.1273 54.663H38.4351L38.2378 53.1784H37.075L36.8778 54.663H35.2893ZM37.1996 51.8599H38.1132L37.6564 47.842L37.1996 51.8599Z"
      fill="white"
    />
    <path
      d="M29.7661 54.663V46.4404H32.5277C33.2026 46.4404 33.5763 46.5858 33.8463 46.8557C34.1058 47.1153 34.2512 47.4786 34.2512 48.1431V48.7556C34.2512 49.4201 34.1058 49.7835 33.8463 50.043C33.7113 50.178 33.5556 50.2818 33.3479 50.3441C33.6594 50.4479 33.9086 50.6452 34.0643 50.9047C34.1889 51.1124 34.2512 51.3719 34.2512 51.8702V54.663H32.5693V51.7145C32.5693 51.4342 32.507 51.2889 32.4239 51.2058C32.3305 51.1124 32.1748 51.0501 31.9048 51.0501H31.448V54.663H29.7661ZM31.448 49.6796H31.9048C32.1748 49.6796 32.3305 49.6277 32.4239 49.5239C32.507 49.4305 32.5693 49.254 32.5693 48.9321V48.4753C32.5693 48.195 32.507 48.0496 32.4239 47.9666C32.3305 47.8732 32.1748 47.8109 31.9048 47.8109H31.448V49.6796Z"
      fill="white"
    />
    <path
      d="M23.8899 54.663L25.0215 46.4404H27.6067L28.7279 54.663H27.0357L26.8384 53.1784H25.6756L25.4783 54.663H23.8899ZM25.8002 51.8599H26.7138L26.257 47.842L25.8002 51.8599Z"
      fill="white"
    />
    <path
      d="M20.609 54.7045C19.7473 54.7045 19.2074 54.5073 18.8544 54.1543C18.5429 53.8428 18.3665 53.4068 18.3665 52.7008V46.4404H20.0483V52.8981C20.0483 53.1784 20.1106 53.3237 20.1937 53.4068C20.2871 53.5002 20.4325 53.5625 20.609 53.5625C20.7855 53.5625 20.9308 53.5002 21.0243 53.4068C21.1073 53.3237 21.1696 53.1784 21.1696 52.8981V46.4404H22.8515V52.7008C22.8515 53.4068 22.675 53.8428 22.3635 54.1543C22.0106 54.5073 21.4707 54.7045 20.609 54.7045Z"
      fill="white"
    />
    <path
      d="M14.411 54.7456C13.9022 54.7456 13.5285 54.6003 13.2585 54.3407C12.9886 54.0812 12.8433 53.697 12.8433 53.043V48.4126C12.8433 47.6962 13.0198 47.2601 13.3312 46.9487C13.6842 46.5957 14.2241 46.3984 15.0858 46.3984C15.9475 46.3984 16.4874 46.5957 16.8404 46.9487C17.1518 47.2601 17.3283 47.6962 17.3283 48.4126V49.3054H15.6464V48.2049C15.6464 47.9246 15.5841 47.7793 15.5011 47.6962C15.4076 47.6028 15.2623 47.5405 15.0858 47.5405C14.9093 47.5405 14.7639 47.6028 14.6705 47.6962C14.5874 47.7793 14.5252 47.9246 14.5252 48.2049V52.8353C14.5252 53.1156 14.5874 53.261 14.6705 53.344C14.7639 53.4375 14.9093 53.4998 15.0858 53.4998C15.2623 53.4998 15.4076 53.4375 15.5011 53.344C15.5841 53.261 15.6464 53.1156 15.6464 52.8353V51.3818H15.0027V50.0945H17.3283V54.6626H15.6464V54.2473C15.3453 54.6003 14.8989 54.7456 14.411 54.7456Z"
      fill="white"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsLowestPrice'
})

defineProps({
  primaryColor: {
    type: String,
    default: '#361564'
  },
  surfaceColor: {
    type: String,
    default: '#671CC2'
  }
})
</script>
